(function () {
    angular.module('bizPartEngage').directive('bizGoalTaskStatus', bizGoalTaskStatusDirective);

    bizGoalTaskStatusDirective.$inject = ["bizCore"];

    function bizGoalTaskStatusDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                task: '=task'
            },
            templateUrl: bizCoreProvider.getView('bizGoalTaskStatus', 'FrontEnd/Modules/EngagementGoals/Views/Directives/taskStatus.html'),
            bindToController: true,
            controller: bizGoalTaskStatusController,
            controllerAs: 'vm'
        };

        bizGoalTaskStatusController.$inject = [];

        return directive;

        function bizGoalTaskStatusController() {
            var vm = this;

            vm.Init = Init;
            vm.IsExpired = IsExpired;

            function IsExpired(task) {
                return !task.IsCompleted && moment(task.DateLocal) < BizPartCoreHelpers.getDateNow();
            }      
            

            function Init() {
                if (vm.task.IsCompleted) {
                    vm.task.Status = 30;
                }
                else if (vm.IsExpired(vm.task)) {
                    vm.task.Status = 10;
                }
                else if (!vm.IsExpired(vm.task) && !vm.task.IsCompleted) {
                    vm.task.Status = 20;
                }
            }

            vm.$onInit = vm.Init;            
        }
    }

}());